/// <reference types="@angular/localize" />

import { Component } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { config } from './config';

@Component({
  selector: 'unity-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
class AppComponent {}

bootstrapApplication(AppComponent, config).catch(err => console.error(err));
